import { Alert, Box, Link, Text } from '@nimbus-ds/components';
import { useAcknowledgeDomainOrderMutation } from 'domains/Configurations/Domains/domainsApi';
import useTranslationConfigurations from 'domains/Configurations/useTranslationConfigurations';

interface OrderErrorAlertProperties {
  domainName: string;
  payOrderId: string;
  onRetry: () => void;
}

type OrderErrorAlertProps = OrderErrorAlertProperties;

export function OrderErrorAlert({
  domainName,
  payOrderId,
  onRetry,
}: OrderErrorAlertProps) {
  const t = useTranslationConfigurations('domains');
  const [acknowledgeDomainOrder, { isLoading }] =
    useAcknowledgeDomainOrderMutation();

  const handleAcknowledge = () => {
    acknowledgeDomainOrder(payOrderId);
  };

  return (
    <Alert
      appearance="danger"
      onRemove={isLoading ? undefined : handleAcknowledge}
    >
      <Box display="flex" flexDirection="column" gap="2">
        <Text fontSize="caption" fontWeight="bold" color="danger-textHigh">
          {t('landing.errorAlert.title', { domainName })}
        </Text>
        <Link as="a" onClick={onRetry}>
          {t('landing.errorAlert.retryButton')}
        </Link>
      </Box>
    </Alert>
  );
}
